import { render } from "./SquadList.vue?vue&type=template&id=086c8e45"
import script from "./SquadList.vue?vue&type=script&lang=js"
export * from "./SquadList.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__